module.exports = __webpack_public_path__ + "static/img/ONO.6e94543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/ONO.jpg
// module id = Epso
// module chunks = 1